import { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import * as actions from './actions'

export function useClearNotifications(autoClear = true) {
  const dispatch = useDispatch()

  const clearNotifications = useCallback(() => {
    dispatch(actions.clearNotifications())
  }, [dispatch])

  useEffect(() => {
    if (autoClear) {
      clearNotifications()
    }
  }, [autoClear, clearNotifications])

  return {
    clearNotifications,
  }
}
